import { FC } from 'react'
import { Select } from 'antd'
import { OptionProps, SelectValue } from 'antd/lib/select'
import { EmployeeWithBuFragment } from '../../../types'
import PerText from '../Text'
import { useAuth } from '../../../context/auth-context'
import { computeFullname } from '../../../shared/nameDisplayPreferencesUtil'
const { Option } = Select

interface NonParticipantsSelectProps {
  additionalParticipantId?: string
  participantsOptions: EmployeeWithBuFragment[]
  onChangeParticipant: (employee?: EmployeeWithBuFragment) => void
  notFoundContentText: string
  placeholderText: string
}

export const NonParticipantsSelect: FC<NonParticipantsSelectProps> = ({
  additionalParticipantId,
  participantsOptions,
  onChangeParticipant,
  notFoundContentText,
  placeholderText,
}) => {
  const onExtendedChange = (value: SelectValue) => {
    const selectedEmployee = participantsOptions.find((e) => e.id === value)
    onChangeParticipant(selectedEmployee)
  }
  const { user } = useAuth()

  return (
    <Select
      showSearch
      disabled={participantsOptions.length === 0}
      placeholder={placeholderText}
      notFoundContent={notFoundContentText}
      dropdownMenuStyle={{ maxHeight: '178px' }}
      value={additionalParticipantId}
      filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
        if (option && option.props && option.props.children) {
          const perTextProp: React.ReactElement<OptionProps> = option.props.children[0]
          return perTextProp && perTextProp.props && perTextProp.props.children
            ? perTextProp.props.children.toString().toLowerCase().includes(input.trim().toLowerCase())
            : false
        }
        return false
      }}
      onChange={(id: SelectValue) => onExtendedChange(id)}
      className="fullWidth"
    >
      {participantsOptions.map((employee) => (
        <Option key={`employee-${employee.id}`} value={employee.id}>
          <PerText display="inline">{computeFullname(user.nameDisplayPreference, employee.firstName, employee.lastName)}</PerText>
          <PerText appearance="label-small" display="inline" mx="xxs">
            |
          </PerText>
          <PerText appearance="label-small" display="inline">
            {employee.businessUnit.name}
          </PerText>
        </Option>
      ))}
    </Select>
  )
}
